import { useContext, useEffect, useRef, useState } from "react";
import { Context } from "../../context/Context";
import { CreatePayment, VerifyPayment } from "../../api/api";
import SuccessToast from "../toasts/SuccessToast";
import ErrorToast from "../toasts/ErrorToast";
import WarningAlert from "../sweeAlerts/WarningAlert";

const PaymentAmountModal = () => {
  const { setPaymentAmountModal, authUser } = useContext(Context);
  const [amount, setAmount] = useState(0);
  const modalName = useRef(null);
  const closeButton = useRef(null);

  useEffect(() => {
    setPaymentAmountModal(modalName);
  }, []);

  const handleSetAmount = (val) => {
    if (val < 1000000 || isNaN(val)) {
      setAmount({
        name: "1,000,000",
        value: 1000000,
      });
    } else if (val > 50000000) {
      setAmount({
        name: "50,000,000",
        value: 50000000,
      });
    } else {
      setAmount({
        name: val.toLocaleString(),
        value: val,
      });
    }
  };

  const handleChangeAmount = (e) => {
    const rawValue = e.target.value.replace(/[,\٬]/g, "");
    const numericValue = parseInt(rawValue, 10);

    // if (
    //   !isNaN(numericValue) &&
    //   numericValue >= 1_000_000 &&
    //   numericValue <= 50_000_000
    // ) {
    setAmount(isNaN(numericValue) ? 0 : numericValue);
    // }
  };

  const handleSubmit = () => {
    /**
     * Basic client-side validation
     */
    if (!amount || isNaN(amount) || amount <= 0) {
      return ErrorToast("مبلغ وارد شده معتبر نمی‌باشد");
    }

    WarningAlert(
      "",
      "آیا از شارژ کیف پول خود به مبلغ " +
        amount.toLocaleString("en-US") +
        " تومان اطمینان دارید؟",
      "بله، اطمینان دارم",
      "انصراف",
    ).then((res) => {
      if (!res.value) return;

      CreatePayment({
        amount,
        user_id: authUser.id,
      })
        .then(({ data }) => {
          /**
           * Safety check for authority
           */
          if (!data?.payment?.authority) {
            ErrorToast("خطا در ایجاد پرداخت. لطفاً مجدداً تلاش کنید.");
            return;
          }

          window.location.href =
            "https://payment.zarinpal.com/pg/StartPay/" +
            data.payment.authority;
        })
        .catch((error) => {
          /**
           * Network error / timeout
           */
          if (!error.response) {
            ErrorToast("عدم ارتباط با سرور. اتصال اینترنت خود را بررسی کنید.");
            return;
          }

          const { status, data } = error.response;

          switch (status) {
            case 422: {
              const firstError = Object.values(data)?.[0];
              ErrorToast(firstError || "اطلاعات وارد شده نامعتبر است");
              break;
            }

            case 400:
              if (data?.message) {
                ErrorToast(data.message);
              } else {
                const firstError = Object.values(data)?.[0];
                ErrorToast(firstError || "درخواست پرداخت ناموفق بود");
              }
              break;

            case 503:
              ErrorToast(
                "در حال حاضر ارتباط با درگاه پرداخت برقرار نیست. لطفاً بعداً تلاش کنید.",
              );
              break;

            case 404:
              ErrorToast("کاربر یا اطلاعات پرداخت یافت نشد");
              break;

            default:
              ErrorToast("خطای غیرمنتظره‌ای رخ داده است");
          }
        });
    });
  };

  return (
    // Modal
    <div
      className="modal fade"
      id="backupModal"
      tabIndex="-1"
      aria-labelledby="backupModalLable"
      aria-hidden="true"
      ref={modalName}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="backupModalLable">
              شارژ کیف پول
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={closeButton}
            ></button>
          </div>
          <div className="modal-body">
            <div>
              <label htmlFor="defaultFormControlInput" className="form-label">
                مبلغ (تومان)
              </label>
              <input
                type="text"
                className="form-control"
                id="backupName"
                value={amount.toLocaleString("en-US")}
                onChange={handleChangeAmount}
                placeholder="مبلغ مورد نظر را وارد کنید"
                aria-describedby="help"
              />
              <div id="help" className="form-text">
                مبلغ مورد نظر برای شارژ را وارد کنید
              </div>
            </div>
          </div>
          <div className="modal-footer">
            {/* <button
              type="button"
              className="btn btn-outline-success-app mb-2"
              data-bs-dismiss="modal"
            >
              انصراف
            </button> */}
            <button
              type="button"
              className="btn btn-success-app mb-2"
              onClick={handleSubmit}
            >
              تایید
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentAmountModal;
